import withAuth from "../../components/auth";
import { injectIntl } from "react-intl";

function ButtonsList() {
  return (
    <>
      <list-system-buttons />
    </>
  );
}

export default injectIntl(withAuth(ButtonsList));